export default __webpack_public_path__ + "static/media/home-security.64c77ac5.jpg";